import { KeycloakService } from 'keycloak-angular';
import { environment } from '@env';

export function initializeKeycloak(
  keycloak: KeycloakService
): () => Promise<boolean> {
  return () => keycloak.init(environment.keycloak);
}
